import React, {
  useEffect,
  useState,
} from 'react';
import { observer } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import ReactTable from 'react-table';
import PaginationTable from '../../../components/Pagination/PaginationTable';
import getSortHeaderProps from '../../../utils/get-sorted-headers';
import { useStores } from '../../../hooks/use-stores';
import {
  Button,
  Col,
  Row,
} from 'react-bootstrap';
import DateTimePicker from 'react-datetime';
import {
  displayDate,
  getLocaleName,
} from '../../../utils/date';
import { toNumber } from '../../../utils/numbers';
import moment from 'moment-timezone';

const ReportTable = observer((props) => {
  const { t } = props;
  const { materialStore, printStore, newAuthStore, settingsStore, locationsStore } = useStores();
  const [ sorted, setSorted ] = useState([]);
  const { inventoryUsage, inventoryUsageDateFrom, inventoryUsageDateTo } = materialStore;
  const { user } = newAuthStore;
  const validFrom = (date) => date.isSameOrBefore(inventoryUsageDateTo);
  const validTo = (date) => date.isSameOrAfter(inventoryUsageDateFrom);

  useEffect(() => {
    search();
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  const getColumns = () => {
    return [
      {
        headerText: t('Material'),
        accessor: d => d,
        Cell: d => (<div>{materialStore.getMaterialName(d.original)}</div>),
        id: 'itemCode',
        className: 'sticky',
        headerClassName: 'sticky',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Code'),
        accessor: d => d,
        Cell: d => (<div>{d.original.itemCode}</div>),
        id: 'itemCode',
        className: 'sticky',
        headerClassName: 'sticky',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Used'),
        accessor: d => d,
        Cell: d => (<div>{toNumber(d.original.usage, 2)} {d.original.itemInventoryUnitSymbol}</div>),
        id: 'usage',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Ship In'),
        accessor: d => d,
        Cell: d => (<div>{toNumber(d.original.shipment, 2)} {d.original.itemInventoryUnitSymbol}</div>),
        id: 'shipment',
        ...getSortHeaderProps(sorted),
      },
    ];
  };

  const onChangeDate = fieldName => value => {
    materialStore[fieldName] = moment(value);
    search();
  };

  const search = () => {
    materialStore.loadInventoryReport();
  };

  const printReport = () => {
    const timezone = settingsStore.configuration.ianaTimeZone;
    const printDate = displayDate(Date.now(), timezone, 'LLL');
    const plant = locationsStore.currentPlant.description;
    const location = locationsStore.currentLocation.name;
    const html = document.querySelector('.report-table .rt-table').innerHTML;
    const dateFrom = document.querySelector('.report-wrap-table input.date-from').value;
    const dateTo = document.querySelector('.report-wrap-table input.date-to').value;

    printStore.printHtml(`
      <h2>${plant}, ${location}</h2>
      <h3>${dateFrom} - ${dateTo}</h3>
      ${html}
      <h5>${printDate}</h5>
      `);
  };

  return (
    <div className="report-wrap-table">
      <Row>
        <Col sm={8}>
          <div className="input-group input-large date-picker input-daterange margin-bottom-10">
            <DateTimePicker
              inputProps={{ className: 'form-control date-from', placeholder: 'date from' }}
              onChange={onChangeDate('inventoryUsageDateFrom')}
              value={inventoryUsageDateFrom}
              timeFormat={true}
              closeOnSelect={true}
              isValidDate={validFrom}
              locale={getLocaleName(user.language)}
            />
            <span className="input-group-addon"> - </span>
            <DateTimePicker
              inputProps={{ className: 'form-control date-to', placeholder: 'date to' }}
              onChange={onChangeDate('inventoryUsageDateTo')}
              value={inventoryUsageDateTo}
              timeFormat={true}
              closeOnSelect={true}
              isValidDate={validTo}
              locale={getLocaleName(user.language)}
            />
          </div>
        </Col>
        <Col sm={4}>
          <Button className="btn btn-sm btn-simple btn-action pull-right"
            onClick={() => printReport()}>
            <i className="fa fa-print"/> {t('Print')}
          </Button>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <ReactTable
            className="-highlight report-table"
            noDataText={' '}
            data={inventoryUsage}
            columns={getColumns()}
            sorted={sorted}
            onSortedChange={sorted => setSorted(sorted)}
            showPaginationTop={false}
            showPaginationBottom={true}
            showPageSizeOptions={true}
            PaginationComponent={PaginationTable}
            resizable={false}
            minRows={1}
            defaultPageSize={100}
          />
        </Col>
      </Row>
    </div>
  );
});

export default withTranslation()(ReportTable);
